export const TOOLS_DATA = 'TOOLS_DATA';
export const TOOLS_SELECTED = 'TOOLS_SELECTED';
export const TOOLS_CHANGE_PAGE = 'TOOLS_CHANGE_PAGE';
export const TOOLS_VIEW_DOCS = 'TOOLS_VIEW_DOCS';
export const TOOLS_VIEW_DETAIL_DOC = 'TOOLS_VIEW_DETAIL_DOC';
export const TOOLS_SEARCH = 'TOOLS_SEARCH';
export const TOOLS_DETAIL = 'TOOLS_DETAIL';
export const TOOLS_CLEAR = 'TOOLS_CLEAR';
export const TOOLS_VIEW_GRAPH = 'TOOLS_VIEW_GRAPH';